import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@web/atoms';
import { Caption, StyledQuestion, Subheading } from './styles';

export const Question = React.forwardRef(
  // @ts-ignore
  (
    { children, caption, prompt, as, bgColor, subheadline, isUIVariant },
    ref,
  ) => (
    <StyledQuestion
      ref={ref}
      as={as}
      $bgColor={bgColor}
      isUIVariant={isUIVariant}
    >
      <Heading
        headingLevel="h3"
        headingText={prompt}
        position="center"
        typography={'heading3'}
        backgroundColor={bgColor}
        isUIVariant={isUIVariant}
        verticalPadding={1}
      />
      {subheadline && <Subheading>{subheadline}</Subheading>}
      {children}
      {caption && <Caption>{caption}</Caption>}
    </StyledQuestion>
  ),
);

Question.displayName = 'Question';
Question.propTypes = {
  children: PropTypes.node,
  prompt: PropTypes.string.isRequired,
  caption: PropTypes.string,
  as: PropTypes.string,
  bgColor: PropTypes.string,
  subheadline: PropTypes.string,
};
